import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
} from "@angular/core";

import { OnInit } from "@angular/core";
import { DashboardService } from "../../services/dashboard.services";
import { EventBusService } from "../../services/event-bus.service";
import { Subject } from 'rxjs';
import { GlobalCfgService } from 'src/services/globalcfg.service';

@Component({
  selector: "rm-incidents-geo-chart",
  templateUrl: "./geo-chart.component.html",
  styleUrls: ["./geo-chart.component.css"]
})
export class GeoChartComponent implements OnInit, OnChanges, OnDestroy {
  @Input()
  productId: string;

  _gcp: string;
  get gcp() {
    return this._gcp;
  }

  @Input()
  set gcp(val) {
    this._gcp = val;
    this.loadIncidents(null);
  }

  @Input()
  batchNum: string;

  @Input()
  gln: string;

  @Input()
  incidentType: string;

  domain: string;

  showBackBtn: boolean = false;
  showBacBtnSource = new Subject<any>();
  showBackBtnValue$ = this.showBacBtnSource.asObservable();


  searchTxt: string = "";
  incidents = [];

  regionHeader = [["Country", "Incidents"]];
  regionEventResponse: any;
  regionEventData: any;

  level: string = "country";

  subscriptions: any = [];

  constructor(
    private ebService: EventBusService,
    private dashboardService: DashboardService,
    private globalCfgService: GlobalCfgService
  ) {}

  ngOnInit() {
    this.subscriptions.push(
      this.showBackBtnValue$.subscribe((flag) => this.showBackBtn = flag)
    );
    this.loadIncidents(null);
    this.subscriptions.push(
      this.ebService.realtimeEventValue$.subscribe(event => {
        console.log("Received event data....");
      })
    );
  }

  ngOnChanges() {
    this.loadIncidents(null);
  }

  loadIncidents(region) {
    if (!this.gcp && this.globalCfgService.getFullUserObj()["role"] != "admin") {
      this.gcp = this.globalCfgService.getGcp();
    }

    var obj = {};

    if (this.gcp) {
      obj['gcp'] = this.gcp;
    }

    if (this.productId != 'all') {
      obj["gtin"] = this.productId;
    }
    if (this.batchNum) {
      obj["batch"] = this.batchNum;
    }
    if (this.gln) {
      obj["gln"] = this.gln;
    }

    obj['eventType'] = this.incidentType && this.incidentType.length > 0 ? this.incidentType : null;

    this.loadGeoMappedIncidents(obj, region);
  }

  loadGeoMappedIncidents = function(obj, region) {
    if (this.level == "country") {
      obj["country"] = region;
    }
    if (this.level == "state") {
      obj["state"] = region;
    }

    this.dashboardService.regionWiseIncidents(obj).subscribe(response => {
      if (typeof response == 'string') {
        return;
      }

      this.regionEventResponse = Object(response);

      if (this.level == 'country' || this.level == 'state') {
        this.regionEventResponse.forEach(o=> {
          if (this.level == 'country') {
            this.domain = o[0];
          }

          o.shift();

          if (this.level == 'state') {
            o[0] = o[0] == 'Telangana' ? 'Andhra Pradesh' : o[0];
          }
        });
      }

      // if (this.level == 'state') {
      //   this.regionEventResponse.forEach((o) => {
      //     o[0] = region + '-' + o[0];
      //   });
      // }

      this.regionEventData = this.regionHeader.concat(this.regionEventResponse);

      window["google"].charts.load("current", {
        packages: ["geochart"],
        mapsApiKey: "AIzaSyD-9tSrke72PouQMnMX-a7eZSW0jkFMBWY"
      });
      window["google"].charts.setOnLoadCallback(drawRegionsMap);

      var thisObj = this;

      function drawRegionsMap() {
        var data = window["google"].visualization.arrayToDataTable(
          thisObj.regionEventData
        );

        var options = {
          displayMode: 'region',
          colorAxis: { colors: ["#b3d1ff", "#1a55ae"] }
        };

        if (thisObj.domain) {
          options['domain'] = thisObj.domain;
        }

        if (thisObj.level != 'country') {
          options['resolution'] = 'provinces';
          thisObj.showBacBtnSource.next(true);
        } else {
          thisObj.showBacBtnSource.next(false);
        }

        if (region) {
          options["region"] = region;
        }

        var chart = new window["google"].visualization.GeoChart(
          document.getElementById("incidents_geochart_div")
        );

        window["google"].visualization.events.addListener(
          chart,
          "regionClick",
          function(region) {
            console.log("Region clicked: ", region);

            thisObj.loadIncidents(region.region);

            if (thisObj.level == "country") {
              thisObj.level = "state";
            }
          }
        );
        chart.draw(data, options);
      }
    });
  };

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  back() {
    this.level = 'country';
    this.loadIncidents(null);
  }
}
